/* Purchase mirrors delegate to Refresh's one native product form. No cart requests or analytics here. */
(() => {
  function mount() {
    const main = document.querySelector('.lus-pdp-main');
    if (!main || main.dataset.lusMounted) return;
    main.dataset.lusMounted = 'true';
    const form = main.querySelector('product-form form');
    const submit = form?.querySelector('[name="add"]');
    const quantity = main.querySelector('[name="quantity"]');
    const sticky = main.querySelector('[data-lus-sticky]');
    const closing = document.querySelector('.lus-pdp--closing');
    const mobileSticky = window.matchMedia('(max-width: 749px)');
    const actions = [...document.querySelectorAll('[data-lus-purchase]')];
    const price = main.querySelector('[id^="price-"]');
    if (!form || !submit || !sticky) return;
    const controller = new AbortController();
    const { signal } = controller;
    const syncSupportLinks = () => {
      const source = document.querySelector('[data-lus-fitting-source][href]');
      if (!source) return;
      document.querySelectorAll('[data-lus-fitting-help]').forEach(link => {
        link.href = source.href;
        link.target = '_blank';
        link.rel = 'noopener';
      });
    };
    document.querySelectorAll('.lus-care-estimate').forEach(care => {
      const buttons = [...care.querySelectorAll('[data-care-people]')];
      const value = care.querySelector('[data-care-value]');
      const context = care.querySelector('[data-care-context]');
      const select = button => {
        const people = button.dataset.carePeople;
        buttons.forEach(option => option.setAttribute('aria-checked', String(option === button)));
        value.textContent = people === '2' ? care.dataset.two : care.dataset.one;
        context.textContent = people === '2' ? 'Estimated ongoing care when two people regularly use this shower.' : 'Estimated ongoing care.';
      };
      buttons.forEach((button,index) => {
        button.addEventListener('click', () => select(button), { signal });
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'ArrowRight' ? (index + 1) % buttons.length : (index - 1 + buttons.length) % buttons.length;
          buttons[next].focus();
          select(buttons[next]);
        }, { signal });
      });
    });
    const visible = element => {
      if (!element || !element.getClientRects().length) return false;
      const r = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      return style.visibility !== 'hidden' && style.display !== 'none' && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
    };
    let scheduled = false;
    function sync() {
      scheduled = false;
      syncSupportLinks();
      const busy = submit.getAttribute('aria-disabled') === 'true';
      const unavailable = submit.disabled;
      const label = submit.querySelector('span');
      if (!unavailable && label && label.textContent.trim() !== 'Add to bag') label.textContent = 'Add to bag';
      const text = unavailable ? label?.textContent.trim() || 'Unavailable' : busy ? 'Adding…' : 'Add to bag';
      for (const action of actions) {
        if (action.textContent !== text) action.textContent = text;
        const disabled = String(busy || unavailable);
        if (action.getAttribute('aria-disabled') !== disabled) action.setAttribute('aria-disabled', disabled);
      }
      const nativePrice = price?.querySelector('.price--on-sale .price-item--sale') || price?.querySelector('.price-item--regular');
      const variant = main.querySelector('variant-selects,variant-radios')?.currentVariant;
      const variantLabel = variant && variant.title !== 'Default Title' ? ` · ${variant.title}` : '';
      document.querySelectorAll('[data-lus-mirror-price]').forEach(el => {
        const value = price?.classList.contains('visibility-hidden') ? '' : (nativePrice?.textContent.trim() || '') + variantLabel;
        if (el.textContent !== value) el.textContent = value;
      });
      const blocking = [...document.querySelectorAll('dialog[open],[role="dialog"],.menu-drawer,.drawer.active,cart-drawer.active,.cart-notification.active,.ecomsend__Modal')].some(visible);
      const keyboard = /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName) || (window.visualViewport && window.visualViewport.height < innerHeight * .75);
      const previewBar = document.querySelector('#PBarNextFrameWrapper,#preview-bar-iframe');
      const previewOffset = previewBar && visible(previewBar) ? Math.ceil(previewBar.getBoundingClientRect().height) : 0;
      sticky.style.setProperty('--lus-preview-offset', `${previewOffset}px`);
      const beyondPrimaryCta = submit.getBoundingClientRect().bottom <= 0;
      const hideSticky = blocking || keyboard || (!mobileSticky.matches && (!beyondPrimaryCta || visible(closing) || visible(document.querySelector('footer'))));
      if (sticky.hidden !== hideSticky) sticky.hidden = hideSticky;
      sticky.dataset.lusReady = 'true';
      const error = main.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message')?.textContent.trim() || '';
      document.querySelectorAll('[data-lus-purchase-error]').forEach(el => {
        if (el.textContent !== error) el.textContent = error;
        if (el.hidden !== !error) el.hidden = !error;
      });
    }
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(sync); } };
    actions.forEach(action => {
      if (action.tagName !== 'BUTTON') action.setAttribute('role', 'button');
      action.addEventListener('click', event => {
        event.preventDefault();
        if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        if (quantity && !quantity.reportValidity()) { quantity.scrollIntoView({block:'center'}); quantity.focus(); return; }
        form.requestSubmit(submit);
        schedule();
      }, { signal });
      if (action.tagName !== 'BUTTON') action.addEventListener('keydown', event => { if (event.code === 'Space') { event.preventDefault(); action.click(); } }, { signal });
    });
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { attributes: true, childList: true, subtree: true, characterData: true, attributeFilter: ['class','hidden','open','disabled','aria-disabled','style'] });
    for (const name of ['scroll','resize','focusin','focusout','change']) window.addEventListener(name,schedule,{passive:true,signal});
    mobileSticky.addEventListener('change', schedule, { signal });
    window.visualViewport?.addEventListener('resize',schedule,{signal});
    document.addEventListener('shopify:section:unload', event => { if(event.target.contains(main)){controller.abort();observer.disconnect();} },{signal});
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount); else mount();
  document.addEventListener('shopify:section:load',mount);
})();
